<!--  Main Toolbar -->
<ng-container *ngIf="isAuthenticated && navigation && !isLoading">
  <mat-sidenav-container>
    <mat-sidenav *ngIf="navigation.length > 0" mode="side" opened class="main-navigation">
      <div class="logo-container">
        <a routerLink="/"><img class="by-lynnco-icon" src="../assets/images/header/Logo-Lynnco-Imperia.svg" alt="imperialynnco"></a>
      </div>
      <mat-nav-list>
        <app-sidenav-list *ngFor="let item of navigation" [item]="item"></app-sidenav-list>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="content">
        <router-outlet></router-outlet>
        <div *ngIf="navigation.length === 0" fxLayout="row">
          <mat-card appearance="outlined" class="card-error" fxLayoutGap="5pt" fxLayoutAlign="start center" fxFlex="50">
            <mat-icon class="material-icons">error</mat-icon>
            <span><b>You do not have permissions configured! Please contact support.</b></span>
          </mat-card>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
<ng-container *ngIf="!isAuthenticated && navigation?.length === 0 && !isLoading">
  <mat-toolbar>
    <div fxFlex="75" fxLayoutAlign="start center">
      <a routerLink="/"><img class="imperia-icon" src="../assets/images/header/Imperia_Logo_LightMode.png" alt="imperia"></a>
      <a routerLink="/"><img class="by-lynnco-icon" src="../assets/images/header/imperiaByLynnco.png" alt="imperialynnco"></a>
    </div>
  </mat-toolbar>
  <div class="content" fxLayout="row">
    <mat-card appearance="outlined" class="content card-error" fxLayoutGap="5pt" fxLayoutAlign="start center" fxFlex="50">
      <mat-icon class="material-icons">error</mat-icon>
      <span><b>Your user has not been configured yet! Please contact support.</b></span>
    </mat-card>
  </div>
</ng-container>
<app-loading *ngIf="isLoading"></app-loading>
